import { LegacyRef, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import Section from '@r1-frontend/ui-react/experimental/blocks/section';
import { BlockContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { IRetailPoint } from '~/src/api/content/retail-point';
import { openCitySelect } from '~/src/components/CitySelectContainer/store/actionCreators';
import { prepareMapOptions, YandexMap } from '~/src/components/YandexMap';
import NoSSR from '~/src/helpers/noSSR';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';

import { Container } from '~/src/features/contact/components/Header/styled';
import * as ST from './styled';

interface IProps {
    contacts: IRetailPoint[],
}

const Map = ({ contacts }: IProps) => {
    const dispatch = useDispatch();
    const { cityIn, name } = useSelector(getCurrentCity);
    const companyName = useSelector(selectCompanyName);

    const mapWrapperRef = useRef<HTMLDivElement>(null);
    const mapInstanceRef: LegacyRef<YandexMap> = useRef(null);
    const displayedMapPoints = prepareMapOptions(contacts);
    const openCitySelectHandler = () => dispatch(openCitySelect());

    const handleAddressClick = (id: string) => () => {
        const mapWrapper = mapWrapperRef?.current;
        const mapInstance = mapInstanceRef?.current;
        if (mapWrapper && mapInstance) {
            mapInstance.openMapBalloon(id);
            mapWrapper.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    };

    return (
        <Section>
            <Container>
                <ST.Grid>
                    <BlockContainer indent={{ $united: [24] }} rounder={{ $radius: 32 }}>
                        {displayedMapPoints.length > 0
                            ? <>
                                <H3>
                                    Адреса наших партнёров
                                </H3>
                                <ST.SWithoutPointList data-test='contact-list'>
                                    {displayedMapPoints.map(({ id, misc, address }) => <ST.ListItem key={id}>
                                        <BlockContainer indent={{ $united: [16] }} rounder={{ $radius: 24 }} bgColor={COLORS.BgMain} >
                                            <ListContainer $size={4} $direction='column'>
                                                <ControlElement onClick={handleAddressClick(id)}>{misc}</ControlElement>
                                                {address}
                                            </ListContainer>
                                        </BlockContainer>
                                    </ST.ListItem>)}
                                </ST.SWithoutPointList>
                            </>
                            : <H3 $withIndent={false}>
                                В&nbsp;<ST.SControlElement as='a'
                                    data-test='city-select-btn'
                                    onClick={openCitySelectHandler}
                                    tabIndex={0}
                                >{cityIn}</ST.SControlElement> не&nbsp;найдено сервисных центров и&nbsp;партнёров {companyName}
                            </H3>}
                    </BlockContainer>
                    <ST.MapWrapper ref={mapWrapperRef} $desktop={32} $mobile={24}>
                        <NoSSR>
                            <YandexMap ref={mapInstanceRef} points={displayedMapPoints} cityName={name} />
                        </NoSSR>
                    </ST.MapWrapper>
                </ST.Grid>
            </Container>
        </Section >
    );
};

export default Map;
